import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import { Divider } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { head, map } from 'lodash';

import styles from 'styles/TBenefits';
import KFlatButton from 'components/KJRN/KFlatButton';
import dateFormat from 'utils/dateTools';
import TLoading from './TLoading';
import TMessage from './TMessage';
import TG from '../../sites/transportationGrants';
import { fetch, register } from '../../sites/transportationGrants/actions';
import KListItem from '../../components/KJRN/KListItem';

const TTransportationGrants = () => {
  const dispatch = useDispatch();
  const {
    transportationGrants, registerLoadingById, grantsLoading, grantsError, registerError,
  } = useSelector(state => state.TransportationGrantReducer);

  useEffect(() => {
    dispatch(fetch());
  }, []);

  if (grantsLoading) {
    return <TLoading />;
  }
  if (grantsError || registerError) {
    return <TMessage type="error" message="transportationGrants.error" values={{ error: grantsError }} />;
  }
  if (!transportationGrants || !transportationGrants.length) {
    return <TMessage message="transportationGrants.empty" />;
  }
  if (transportationGrants.length === 1) {
    const grant = head(transportationGrants);
    return <TG.TransportationGrant embed onSubmit={transportGrant => dispatch(register(transportGrant))} grant={grant} loaded={registerLoadingById[grant.HrTransportationGrantID]} />;
  }
  return (
    <div style={styles.container} >
      <div style={{ maxHeight: 422, overflow: 'auto', height: '100%' }}>
        {map(transportationGrants, (grant, key) => (
          <div key={key}>
            <KListItem
              innerDivStyle={styles.link}
              primaryText={grant.HrTransportationGrantName}
              secondaryText={grant.Previous ? (
                  `${dateFormat(grant.Previous.Begda)} - ${dateFormat(grant.Previous.Endda)}`
                ) : <div><FormattedMessage id="unused" /></div>}
              hoverColor="transparent"
              onClick={() => dispatch(push('/transportation'))}
            />
            <Divider key="div" style={styles.spacer} />
          </div>
          ))}
      </div>
      <KFlatButton
        data-cy="transportation-grants-button"
        style={styles.actionButton}
        onClick={() => dispatch(push('/transportation'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.transportations.goto" />}
      />
    </div>
  );
};

export default TTransportationGrants;




// WEBPACK FOOTER //
// ./src/containers/tiles/TTransportationGrants.js